import { OrderAheadController } from './lib';

export default OrderAheadController;
export { useOrderAheadNavigationOnClick, getOrderAheadTabIcon } from './lib';
